function Token(token, expirationMonth, expirationYear, authorizeStatus, reasonCode, reasonDescription) {
  this.Token = token;
  
  if(expirationMonth){
    this.ExpirationMonth = expirationMonth;  
  }
  if(expirationYear){
    this.ExpirationYear = expirationYear;
  }
  if(reasonCode){
    this.ReasonCode = reasonCode;
  }
  if(reasonDescription || reasonDescription === ""){
    this.ReasonDescription = reasonDescription;
  }
}

module.exports = Token;



//////////////////
// WEBPACK FOOTER
// ./models/token.js
// module id = 50
// module chunks = 0 5 20